import { SolanaSignAndSendTransaction, SolanaSignIn, SolanaSignMessage, SolanaSignTransaction } from "@solana/wallet-standard-features";
import { SolanaMobileWalletAdapterError, SolanaMobileWalletAdapterErrorCode, startRemoteScenario, startScenario } from "@solana-mobile/mobile-wallet-adapter-protocol";
import { StandardConnect, StandardDisconnect, StandardEvents } from "@wallet-standard/features";
import base58 from "bs58";
import QRCode from "qrcode";
import { registerWallet } from "@wallet-standard/wallet";
import { SOLANA_MAINNET_CHAIN } from "@solana/wallet-standard-chains";
//#region src/base64Utils.ts
function fromUint8Array(byteArray) {
	return window.btoa(String.fromCharCode.call(null, ...byteArray));
}
function toUint8Array(base64EncodedByteArray) {
	return new Uint8Array(window.atob(base64EncodedByteArray).split("").map((c) => c.charCodeAt(0)));
}
//#endregion
//#region src/embedded-modal/loadingSpinner.ts
const modalHtml$1 = `
<div class="mobile-wallet-adapter-embedded-loading-indicator" role="dialog" aria-modal="true" aria-labelledby="modal-title">
    <div data-modal-close style="position: absolute; width: 100%; height: 100%;"></div>
    <div class="mobile-wallet-adapter-embedded-loading-container">
        <div class="mobile-wallet-adapter-embedded-loading-animation"></div>
    </div>
</div>
`;
const css$6 = `
.mobile-wallet-adapter-embedded-loading-indicator {
    display: flex; /* Use flexbox to center content */
    justify-content: center; /* Center horizontally */
    align-items: start; /* Center vertically */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    overflow-y: auto; /* enable scrolling */
}

.mobile-wallet-adapter-embedded-loading-container {
    display: flex;
    margin: auto;
}

.mobile-wallet-adapter-embedded-loading-animation {
    position: relative;
    left: -9999px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: var(--spinner-color);
    color: var(--spinner-color);
    box-shadow: 9984px 0 0 0 var(--spinner-color), 
                9999px 0 0 0 var(--spinner-color), 
                10014px 0 0 0 var(--spinner-color);
    animation: dot-typing 1.5s infinite linear;
}

@keyframes dot-typing {
    0% {
        box-shadow: 9984px 0 0 0 var(--spinner-color), 
                    9999px 0 0 0 var(--spinner-color), 
                    10014px 0 0 0 var(--spinner-color);
    }
    16.667% {
        box-shadow: 9984px -10px 0 0 var(--spinner-color), 
                    9999px 0 0 0 var(--spinner-color), 
                    10014px 0 0 0 var(--spinner-color);
    }
    33.333% {
        box-shadow: 9984px 0 0 0 var(--spinner-color), 
                    9999px 0 0 0 var(--spinner-color), 
                    10014px 0 0 0 var(--spinner-color);
    }
    50% {
        box-shadow: 9984px 0 0 0 var(--spinner-color), 
                    9999px -10px 0 0 var(--spinner-color), 
                    10014px 0 0 0 var(--spinner-color);
    }
    66.667% {
        box-shadow: 9984px 0 0 0 var(--spinner-color), 
                    9999px 0 0 0 var(--spinner-color), 
                    10014px 0 0 0 var(--spinner-color);
    }
    83.333% {
        box-shadow: 9984px 0 0 0 var(--spinner-color), 
                    9999px 0 0 0 var(--spinner-color), 
                    10014px -10px 0 0 var(--spinner-color);
    }
    100% {
        box-shadow: 9984px 0 0 0 var(--spinner-color), 
                    9999px 0 0 0 var(--spinner-color), 
                    10014px 0 0 0 var(--spinner-color);
    }
}
`;
var EmbeddedLoadingSpinner = class {
	#root = null;
	#eventListeners = {};
	#listenersAttached = false;
	dom = null;
	constructor() {
		this.init = this.init.bind(this);
		this.#root = document.getElementById("mobile-wallet-adapter-embedded-root-ui");
	}
	async init() {
		console.log("Injecting modal");
		this.#injectHTML();
	}
	open = () => {
		console.debug("Modal open");
		this.#attachEventListeners();
		if (this.#root) this.#root.style.display = "flex";
	};
	close = (event = void 0) => {
		console.debug("Modal close");
		this.#removeEventListeners();
		if (this.#root) this.#root.style.display = "none";
		this.#eventListeners["close"]?.forEach((listener) => listener(event));
	};
	addEventListener(event, listener) {
		this.#eventListeners[event]?.push(listener) || (this.#eventListeners[event] = [listener]);
		return () => this.removeEventListener(event, listener);
	}
	removeEventListener(event, listener) {
		this.#eventListeners[event] = this.#eventListeners[event]?.filter((existingListener) => listener !== existingListener);
	}
	#injectHTML() {
		if (this.dom) return;
		this.#root = document.createElement("div");
		this.#root.id = "mobile-wallet-adapter-embedded-root-ui";
		this.#root.innerHTML = modalHtml$1;
		this.#root.style.display = "none";
		const styles = document.createElement("style");
		styles.id = "mobile-wallet-adapter-embedded-modal-styles";
		styles.textContent = css$6;
		const host = document.createElement("div");
		this.dom = host.attachShadow({ mode: "closed" });
		host.style.setProperty("--spinner-color", "#FFFFFF");
		this.dom.appendChild(styles);
		this.dom.appendChild(this.#root);
		document.body.appendChild(host);
	}
	#attachEventListeners() {
		if (!this.#root || this.#listenersAttached) return;
		[...this.#root.querySelectorAll("[data-modal-close]")].forEach((closer) => closer?.addEventListener("click", (event) => {
			this.close(event);
		}));
		window.addEventListener("load", this.close);
		document.addEventListener("keydown", this.#handleKeyDown);
		this.#listenersAttached = true;
	}
	#removeEventListeners() {
		if (!this.#listenersAttached) return;
		window.removeEventListener("load", this.close);
		document.removeEventListener("keydown", this.#handleKeyDown);
		if (!this.#root) return;
		[...this.#root.querySelectorAll("[data-modal-close]")].forEach((closer) => closer?.removeEventListener("click", this.close));
		this.#listenersAttached = false;
	}
	#handleKeyDown = (event) => {
		if (event.key === "Escape") this.close(event);
	};
};
//#endregion
//#region src/embedded-modal/modal.ts
const modalHtml = `
<div class="mobile-wallet-adapter-embedded-modal-container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
    <div data-modal-close style="position: absolute; width: 100%; height: 100%;"></div>
	<div class="mobile-wallet-adapter-embedded-modal-card">
		<div>
			<button data-modal-close class="mobile-wallet-adapter-embedded-modal-close">
				<svg width="14" height="14">
					<path d="M 6.7125,8.3036995 1.9082,13.108199 c -0.2113,0.2112 -0.4765,0.3168 -0.7957,0.3168 -0.3192,0 -0.5844,-0.1056 -0.7958,-0.3168 C 0.1056,12.896899 0,12.631699 0,12.312499 c 0,-0.3192 0.1056,-0.5844 0.3167,-0.7958 L 5.1212,6.7124995 0.3167,1.9082 C 0.1056,1.6969 0,1.4317 0,1.1125 0,0.7933 0.1056,0.5281 0.3167,0.3167 0.5281,0.1056 0.7933,0 1.1125,0 1.4317,0 1.6969,0.1056 1.9082,0.3167 L 6.7125,5.1212 11.5167,0.3167 C 11.7281,0.1056 11.9933,0 12.3125,0 c 0.3192,0 0.5844,0.1056 0.7957,0.3167 0.2112,0.2114 0.3168,0.4766 0.3168,0.7958 0,0.3192 -0.1056,0.5844 -0.3168,0.7957 L 8.3037001,6.7124995 13.1082,11.516699 c 0.2112,0.2114 0.3168,0.4766 0.3168,0.7958 0,0.3192 -0.1056,0.5844 -0.3168,0.7957 -0.2113,0.2112 -0.4765,0.3168 -0.7957,0.3168 -0.3192,0 -0.5844,-0.1056 -0.7958,-0.3168 z" />
				</svg>
			</button>
		</div>
		<div class="mobile-wallet-adapter-embedded-modal-content"></div>
	</div>
</div>
`;
const css$5 = `
.mobile-wallet-adapter-embedded-modal-container {
    display: flex; /* Use flexbox to center content */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    position: fixed; /* Stay in place */
    z-index: 2147483647; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    overflow-y: auto; /* enable scrolling */
}

.mobile-wallet-adapter-embedded-modal-card {
    display: flex;
    flex-direction: column;
    margin: auto 20px;
    max-width: 780px;
    padding: 20px;
    border-radius: 24px;
    background: #ffffff;
    font-family: "Inter Tight", "PT Sans", Calibri, sans-serif;
    transform: translateY(-200%);
    animation: slide-in 0.5s forwards;
}

@keyframes slide-in {
    100% { transform: translateY(0%); }
}

.mobile-wallet-adapter-embedded-modal-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    cursor: pointer;
    background: #e4e9e9;
    border: none;
    border-radius: 50%;
}

.mobile-wallet-adapter-embedded-modal-close:focus-visible {
    outline-color: red;
}

.mobile-wallet-adapter-embedded-modal-close svg {
    fill: #546266;
    transition: fill 200ms ease 0s;
}

.mobile-wallet-adapter-embedded-modal-close:hover svg {
    fill: #fff;
}
`;
const fonts = `
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Inter+Tight:ital,wght@0,100..900;1,100..900&display=swap" rel="stylesheet">
`;
var EmbeddedModal = class {
	#root = null;
	#eventListeners = {};
	#listenersAttached = false;
	dom = null;
	constructor() {
		this.init = this.init.bind(this);
		this.#root = document.getElementById("mobile-wallet-adapter-embedded-root-ui");
	}
	async init() {
		console.log("Injecting modal");
		this.#injectHTML();
	}
	open = () => {
		console.debug("Modal open");
		this.#attachEventListeners();
		if (this.#root) this.#root.style.display = "flex";
	};
	close = (event = void 0) => {
		console.debug("Modal close");
		this.#removeEventListeners();
		if (this.#root) this.#root.style.display = "none";
		this.#eventListeners["close"]?.forEach((listener) => listener(event));
	};
	addEventListener(event, listener) {
		this.#eventListeners[event]?.push(listener) || (this.#eventListeners[event] = [listener]);
		return () => this.removeEventListener(event, listener);
	}
	removeEventListener(event, listener) {
		this.#eventListeners[event] = this.#eventListeners[event]?.filter((existingListener) => listener !== existingListener);
	}
	#injectHTML() {
		if (document.getElementById("mobile-wallet-adapter-embedded-root-ui")) {
			if (!this.#root) this.#root = document.getElementById("mobile-wallet-adapter-embedded-root-ui");
			return;
		}
		this.#root = document.createElement("div");
		this.#root.id = "mobile-wallet-adapter-embedded-root-ui";
		this.#root.innerHTML = modalHtml;
		this.#root.style.display = "none";
		const content = this.#root.querySelector(".mobile-wallet-adapter-embedded-modal-content");
		if (content) content.innerHTML = this.contentHtml;
		const styles = document.createElement("style");
		styles.id = "mobile-wallet-adapter-embedded-modal-styles";
		styles.textContent = css$5 + this.contentStyles;
		const host = document.createElement("div");
		host.innerHTML = fonts;
		this.dom = host.attachShadow({ mode: "closed" });
		this.dom.appendChild(styles);
		this.dom.appendChild(this.#root);
		document.body.appendChild(host);
	}
	#attachEventListeners() {
		if (!this.#root || this.#listenersAttached) return;
		[...this.#root.querySelectorAll("[data-modal-close]")].forEach((closer) => closer?.addEventListener("click", this.close));
		window.addEventListener("load", this.close);
		document.addEventListener("keydown", this.#handleKeyDown);
		this.#listenersAttached = true;
	}
	#removeEventListeners() {
		if (!this.#listenersAttached) return;
		window.removeEventListener("load", this.close);
		document.removeEventListener("keydown", this.#handleKeyDown);
		if (!this.#root) return;
		[...this.#root.querySelectorAll("[data-modal-close]")].forEach((closer) => closer?.removeEventListener("click", this.close));
		this.#listenersAttached = false;
	}
	#handleKeyDown = (event) => {
		if (event.key === "Escape") this.close(event);
	};
};
//#endregion
//#region src/embedded-modal/remoteConnectionModal.ts
var RemoteConnectionModal = class extends EmbeddedModal {
	contentStyles = css$4;
	contentHtml = QRCodeHtml;
	async initWithQR(qrCode) {
		super.init();
		this.populateQRCode(qrCode);
	}
	async populateQRCode(qrUrl) {
		const qrcodeContainer = this.dom?.getElementById("mobile-wallet-adapter-embedded-modal-qr-code-container");
		if (qrcodeContainer) {
			const qrCodeElement = await QRCode.toCanvas(qrUrl, {
				width: 200,
				margin: 0
			});
			if (qrcodeContainer.firstElementChild !== null) qrcodeContainer.replaceChild(qrCodeElement, qrcodeContainer.firstElementChild);
			else qrcodeContainer.appendChild(qrCodeElement);
			const qrPlaceholder = this.dom?.getElementById("mobile-wallet-adapter-embedded-modal-qr-placeholder");
			if (qrPlaceholder) qrPlaceholder.style.display = "none";
		} else console.error("QRCode Container not found");
	}
};
const QRCodeHtml = `
<div class="mobile-wallet-adapter-embedded-modal-qr-content">
    <div>
        <svg class="mobile-wallet-adapter-embedded-modal-icon" width="100%" height="100%">
            <circle r="52" cx="53" cy="53" fill="#99b3be" stroke="#000000" stroke-width="2"/>
            <path d="m 53,82.7305 c -3.3116,0 -6.1361,-1.169 -8.4735,-3.507 -2.338,-2.338 -3.507,-5.1625 -3.507,-8.4735 0,-3.3116 1.169,-6.1364 3.507,-8.4744 2.3374,-2.338 5.1619,-3.507 8.4735,-3.507 3.3116,0 6.1361,1.169 8.4735,3.507 2.338,2.338 3.507,5.1628 3.507,8.4744 0,3.311 -1.169,6.1355 -3.507,8.4735 -2.3374,2.338 -5.1619,3.507 -8.4735,3.507 z m 0.007,-5.25 c 1.8532,0 3.437,-0.6598 4.7512,-1.9793 1.3149,-1.3195 1.9723,-2.9058 1.9723,-4.7591 0,-1.8526 -0.6598,-3.4364 -1.9793,-4.7512 -1.3195,-1.3149 -2.9055,-1.9723 -4.7582,-1.9723 -1.8533,0 -3.437,0.6598 -4.7513,1.9793 -1.3148,1.3195 -1.9722,2.9058 -1.9722,4.7591 0,1.8527 0.6597,3.4364 1.9792,4.7512 1.3195,1.3149 2.9056,1.9723 4.7583,1.9723 z m -28,-33.5729 -3.85,-3.6347 c 4.1195,-4.025 8.8792,-7.1984 14.2791,-9.52 5.4005,-2.3223 11.2551,-3.4834 17.5639,-3.4834 6.3087,0 12.1634,1.1611 17.5639,3.4834 5.3999,2.3216 10.1596,5.495 14.2791,9.52 l -3.85,3.6347 C 77.2999,40.358 73.0684,37.5726 68.2985,35.5514 63.5292,33.5301 58.4296,32.5195 53,32.5195 c -5.4297,0 -10.5292,1.0106 -15.2985,3.0319 -4.7699,2.0212 -9.0014,4.8066 -12.6945,8.3562 z m 44.625,10.8771 c -2.2709,-2.1046 -4.7962,-3.7167 -7.5758,-4.8361 -2.7795,-1.12 -5.7983,-1.68 -9.0562,-1.68 -3.2579,0 -6.2621,0.56 -9.0125,1.68 -2.7504,1.1194 -5.2903,2.7315 -7.6195,4.8361 L 32.5189,51.15 c 2.8355,-2.6028 5.9777,-4.6086 9.4263,-6.0174 3.4481,-1.4087 7.133,-2.1131 11.0548,-2.1131 3.9217,0 7.5979,0.7044 11.0285,2.1131 3.43,1.4088 6.5631,3.4146 9.3992,6.0174 z"/>
        </svg>
        <div class="mobile-wallet-adapter-embedded-modal-title">Remote Mobile Wallet Adapter</div>
    </div>
    <div>
        <div>
            <h4 class="mobile-wallet-adapter-embedded-modal-qr-label">
                Open your wallet and scan this code
            </h4>
        </div>
        <div id="mobile-wallet-adapter-embedded-modal-qr-code-container" class="mobile-wallet-adapter-embedded-modal-qr-code-container">
            <div id="mobile-wallet-adapter-embedded-modal-qr-placeholder" class="mobile-wallet-adapter-embedded-modal-qr-placeholder"></div>
        </div>
    </div>
</div>
<div class="mobile-wallet-adapter-embedded-modal-divider"><hr></div>
<div class="mobile-wallet-adapter-embedded-modal-footer">
    <div class="mobile-wallet-adapter-embedded-modal-subtitle">
        Follow the instructions on your device. When you're finished, this screen will update.
    </div>
    <div class="mobile-wallet-adapter-embedded-modal-progress-badge">
        <div>
            <div class="spinner">
                <div class="leftWrapper">
                    <div class="left">
                        <div class="circle"></div>
                    </div>
                </div>
                <div class="rightWrapper">
                    <div class="right">
                        <div class="circle"></div>
                    </div>
                </div>
            </div>
        </div>
        <div>Waiting for scan</div>
    </div>
</div>
`;
const css$4 = `
.mobile-wallet-adapter-embedded-modal-qr-content {
    display: flex; 
    margin-top: 10px;
    padding: 10px;
}

.mobile-wallet-adapter-embedded-modal-qr-content > div:first-child {
    display: flex;
    flex-direction: column;
    flex: 2;
    margin-top: auto;
    margin-right: 30px;
}

.mobile-wallet-adapter-embedded-modal-qr-content > div:nth-child(2) {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-left: auto;
}

.mobile-wallet-adapter-embedded-modal-footer {
    display: flex;
    padding: 10px;
}

.mobile-wallet-adapter-embedded-modal-icon {}

.mobile-wallet-adapter-embedded-modal-title {
    color: #000000;
    font-size: 2.5em;
    font-weight: 600;
}

.mobile-wallet-adapter-embedded-modal-qr-label {
    text-align: right;
    color: #000000;
}

.mobile-wallet-adapter-embedded-modal-qr-code-container {
    margin-left: auto;
}

.mobile-wallet-adapter-embedded-modal-qr-placeholder {
    margin-left: auto;
    min-width: 200px;
    min-height: 200px;
    background: linear-gradient(-60deg, #F7F8F8 30%, #ECEEEE 50%, #F7F8F8 70%);
    background-size: 200%;
    animation: placeholderAnimate 2.7s linear infinite;
    border-radius: 12px;
}

.mobile-wallet-adapter-embedded-modal-divider {
    margin-top: 20px;
    padding-left: 10px;
    padding-right: 10px;
}

.mobile-wallet-adapter-embedded-modal-divider hr {
    border-top: 1px solid #D9DEDE;
}

.mobile-wallet-adapter-embedded-modal-subtitle {
    margin: auto;
    margin-right: 60px;
    padding: 20px;
    color: #6E8286;
}

.mobile-wallet-adapter-embedded-modal-progress-badge {
    display: flex;
    background: #F7F8F8;
    height: 56px;
    min-width: 200px;
    margin: auto;
    padding-left: 20px;
    padding-right: 20px;
    border-radius: 18px;
    color: #A8B6B8;
    align-items: center;
}

.mobile-wallet-adapter-embedded-modal-progress-badge > div:first-child {
    margin-left: auto;
    margin-right: 20px;
}

.mobile-wallet-adapter-embedded-modal-progress-badge > div:nth-child(2) {
    margin-right: auto;
}

/* Smaller screens */
@media all and (max-width: 600px) {
    .mobile-wallet-adapter-embedded-modal-card {
        text-align: center;
    }
    .mobile-wallet-adapter-embedded-modal-qr-content {
        flex-direction: column;
    }
    .mobile-wallet-adapter-embedded-modal-qr-content > div:first-child {
        margin: auto;
    }
    .mobile-wallet-adapter-embedded-modal-qr-content > div:nth-child(2) {
        margin: auto;
        flex: 2 auto;
    }
    .mobile-wallet-adapter-embedded-modal-footer {
        flex-direction: column;
    }
    .mobile-wallet-adapter-embedded-modal-icon {
        display: none;
    }
    .mobile-wallet-adapter-embedded-modal-title {
        font-size: 1.5em;
    }
    .mobile-wallet-adapter-embedded-modal-subtitle {
        margin-right: unset;
    }
    .mobile-wallet-adapter-embedded-modal-qr-label {
        text-align: center;
    }
    .mobile-wallet-adapter-embedded-modal-qr-code-container {
        margin: auto;
    }
    .mobile-wallet-adapter-embedded-modal-qr-placeholder {
        margin: auto;
    }
}

/* QR Placeholder */
@keyframes placeholderAnimate {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}

/* Spinner */
@keyframes spinLeft {
    0% {
        transform: rotate(20deg);
    }
    50% {
        transform: rotate(160deg);
    }
    100% {
        transform: rotate(20deg);
    }
}
@keyframes spinRight {
    0% {
        transform: rotate(160deg);
    }
    50% {
        transform: rotate(20deg);
    }
    100% {
        transform: rotate(160deg);
    }
}
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(2520deg);
    }
}

.spinner {
    position: relative;
    width: 1.5em;
    height: 1.5em;
    margin: auto;
    animation: spin 10s linear infinite;
}
.spinner::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.right, .rightWrapper, .left, .leftWrapper {
    position: absolute;
    top: 0;
    overflow: hidden;
    width: .75em;
    height: 1.5em;
}
.left, .leftWrapper {
    left: 0;
}
.right {
    left: -12px;
}
.rightWrapper {
    right: 0;
}
.circle {
    border: .125em solid #A8B6B8;
    width: 1.25em; /* 1.5em - 2*0.125em border */
    height: 1.25em; /* 1.5em - 2*0.125em border */
    border-radius: 0.75em; /* 0.5*1.5em spinner size 8 */
}
.left {
    transform-origin: 100% 50%;
    animation: spinLeft 2.5s cubic-bezier(.2,0,.8,1) infinite;
}
.right {
    transform-origin: 100% 50%;
    animation: spinRight 2.5s cubic-bezier(.2,0,.8,1) infinite;
}
`;
//#endregion
//#region src/embedded-modal/localConnectionModal.ts
var LocalConnectionModal = class extends EmbeddedModal {
	contentStyles = css$3;
	contentHtml = ErrorDialogHtml$3;
	initWithCallback(callback) {
		super.init();
		this.#prepareLaunchAction(callback);
	}
	#prepareLaunchAction(callback) {
		const launchButton = this.dom?.getElementById("mobile-wallet-adapter-launch-action");
		const listener = async () => {
			launchButton?.removeEventListener("click", listener);
			this.close();
			callback();
		};
		launchButton?.addEventListener("click", listener);
	}
};
const ErrorDialogHtml$3 = `
<svg class="mobile-wallet-adapter-embedded-modal-launch-icon" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.6 48C7.2 48 0 40.8 0 26.4V21.6C0 7.2 7.2 0 21.6 0H26.4C40.8 0 48 7.2 48 21.6V26.4C48 40.8 40.8 48 26.4 48H21.6Z" fill="#15994E"/>
    <mask id="mask0_189_522" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="8" y="8" width="32" height="32">
        <rect x="8" y="8" width="32" height="32" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_189_522)">
        <mask id="mask1_189_522" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="8" y="8" width="32" height="32">
            <rect x="8" y="8" width="32" height="32" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask1_189_522)">
            <path d="M22.1092 26.1208L19.4498 23.4615C19.1736 23.1851 18.8253 23.0468 18.4048 23.0468C17.9846 23.0468 17.6363 23.1851 17.3598 23.4615C17.0836 23.7377 16.9468 24.0861 16.9495 24.5065C16.9522 24.9267 17.0916 25.275 17.3678 25.5512L21.0405 29.2238C21.3463 29.5276 21.7031 29.6795 22.1108 29.6795C22.5184 29.6795 22.8742 29.5276 23.1782 29.2238L30.5918 21.8098C30.8683 21.5336 31.0065 21.1867 31.0065 20.7692C31.0065 20.3514 30.8683 20.0044 30.5918 19.7282C30.3156 19.4517 29.9673 19.3135 29.5468 19.3135C29.1266 19.3135 28.7784 19.4517 28.5022 19.7282L22.1092 26.1208ZM23.9998 37.6042C22.113 37.6042 20.3425 37.2473 18.6885 36.5335C17.0343 35.8197 15.5954 34.8512 14.3718 33.6278C13.1485 32.4043 12.18 30.9654 11.4662 29.3112C10.7524 27.6572 10.3955 25.8867 10.3955 23.9998C10.3955 22.113 10.7524 20.3425 11.4662 18.6885C12.18 17.0343 13.1485 15.5954 14.3718 14.3718C15.5954 13.1485 17.0343 12.18 18.6885 11.4662C20.3425 10.7524 22.113 10.3955 23.9998 10.3955C25.8867 10.3955 27.6572 10.7524 29.3112 11.4662C30.9654 12.18 32.4043 13.1485 33.6278 14.3718C34.8512 15.5954 35.8197 17.0343 36.5335 18.6885C37.2473 20.3425 37.6042 22.113 37.6042 23.9998C37.6042 25.8867 37.2473 27.6572 36.5335 29.3112C35.8197 30.9654 34.8512 32.4043 33.6278 33.6278C32.4043 34.8512 30.9654 35.8197 29.3112 36.5335C27.6572 37.2473 25.8867 37.6042 23.9998 37.6042Z" fill="white"/>
        </g>
    </g>
</svg>
<div class="mobile-wallet-adapter-embedded-modal-title">Ready to connect!</div>
<div>
    <button data-modal-action id="mobile-wallet-adapter-launch-action" class="mobile-wallet-adapter-embedded-modal-launch-action">
        Connect Wallet
    </button>
</div>
`;
const css$3 = `
.mobile-wallet-adapter-embedded-modal-close {
    display: none;
}
.mobile-wallet-adapter-embedded-modal-content {
    text-align: center;
    min-width: 300px;
}
.mobile-wallet-adapter-embedded-modal-launch-icon {
    margin-top: 24px;
}
.mobile-wallet-adapter-embedded-modal-title {
    margin: 18px 100px 30px 100px;
    color: #000000;
    font-size: 2.75em;
    font-weight: 600;
}
.mobile-wallet-adapter-embedded-modal-launch-action {
    display: block;
    width: 100%;
    height: 56px;
    font-size: 1.25em;
    background: #000000;
    color: #FFFFFF;
    border-radius: 18px;
}
/* Smaller screens */
@media all and (max-width: 600px) {
    .mobile-wallet-adapter-embedded-modal-title {
        font-size: 1.5em;
        margin-right: 12px;
        margin-left: 12px;
    }
}
`;
//#endregion
//#region src/embedded-modal/loopbackBlockedModal.ts
var LoopbackPermissionBlockedModal = class extends EmbeddedModal {
	contentStyles = css$2;
	get contentHtml() {
		const instructions = getIsPwaLaunchedAsApp() ? "Long press the app icon on your home screen to open site settings" : "Tap the lock or settings icon in the address bar to open site settings";
		return ErrorDialogHtml$2.replace("{{PERMISSION_INSTRUCTION_DETAIL}}", instructions);
	}
	async init() {
		super.init();
		this.#prepareLaunchAction();
	}
	#prepareLaunchAction() {
		const launchButton = this.dom?.getElementById("mobile-wallet-adapter-launch-action");
		const listener = async (event) => {
			launchButton?.removeEventListener("click", listener);
			this.close(event);
		};
		launchButton?.addEventListener("click", listener);
	}
};
const ErrorDialogHtml$2 = `
<div class="mobile-wallet-adapter-embedded-modal-header">
    Local Wallet Connection
</div>
<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.6 48C7.2 48 0 40.8 0 26.4V21.6C0 7.2 7.2 0 21.6 0H26.4C40.8 0 48 7.2 48 21.6V26.4C48 40.8 40.8 48 26.4 48H21.6Z" fill="#ED1515"/>
    <mask id="mask0_147_1364" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="8" y="8" width="32" height="32">
        <rect x="8" y="8" width="32" height="32" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_147_1364)">
        <path d="M20.1398 36.2705C19.7363 36.2705 19.3508 36.1945 18.9835 36.0425C18.6162 35.8907 18.2916 35.674 18.0098 35.3922L12.6072 29.9895C12.3254 29.7077 12.1086 29.3832 11.9568 29.0158C11.8048 28.6485 11.7288 28.2631 11.7288 27.8595V20.1395C11.7288 19.736 11.8048 19.3505 11.9568 18.9832C12.1086 18.6158 12.3254 18.2913 12.6072 18.0095L18.0098 12.6068C18.2916 12.3251 18.6162 12.1083 18.9835 11.9565C19.3508 11.8045 19.7363 11.7285 20.1398 11.7285H27.8598C28.2634 11.7285 28.6488 11.8045 29.0162 11.9565C29.3835 12.1083 29.708 12.3251 29.9898 12.6068L35.3925 18.0095C35.6743 18.2913 35.891 18.6158 36.0428 18.9832C36.1948 19.3505 36.2708 19.736 36.2708 20.1395V27.8595C36.2708 28.2631 36.1948 28.6485 36.0428 29.0158C35.891 29.3832 35.6743 29.7077 35.3925 29.9895L29.9898 35.3922C29.708 35.674 29.3835 35.8907 29.0162 36.0425C28.6488 36.1945 28.2634 36.2705 27.8598 36.2705H20.1398ZM20.1732 33.2372H27.8265L33.2375 27.8262V20.1728L27.8265 14.7618H20.1732L14.7622 20.1728V27.8262L20.1732 33.2372ZM23.9998 25.9538L26.7868 28.7408C27.0473 29.0013 27.3729 29.1302 27.7638 29.1275C28.1549 29.1248 28.4807 28.9933 28.7412 28.7328C29.0016 28.4724 29.1318 28.1466 29.1318 27.7555C29.1318 27.3646 29.0016 27.039 28.7412 26.7785L25.9542 23.9995L28.7412 21.2125C29.0016 20.9521 29.1318 20.6264 29.1318 20.2355C29.1318 19.8444 29.0016 19.5186 28.7412 19.2582C28.4807 18.9977 28.1549 18.8675 27.7638 18.8675C27.3729 18.8675 27.0473 18.9977 26.7868 19.2582L23.9998 22.0452L21.2128 19.2582C20.9524 18.9977 20.628 18.8675 20.2398 18.8675C19.8514 18.8675 19.5269 18.9977 19.2665 19.2582C19.006 19.5186 18.8758 19.8444 18.8758 20.2355C18.8758 20.6264 19.006 20.9521 19.2665 21.2125L22.0455 23.9995L19.2585 26.7865C18.998 27.047 18.8692 27.3713 18.8718 27.7595C18.8745 28.148 19.006 28.4724 19.2665 28.7328C19.5269 28.9933 19.8527 29.1235 20.2438 29.1235C20.6347 29.1235 20.9604 28.9933 21.2208 28.7328L23.9998 25.9538Z" fill="black"/>
    </g>
</svg>
<div class="mobile-wallet-adapter-embedded-modal-title">
    Your wallet connection is blocked
</div>
<div id="mobile-wallet-adapter-local-launch-message" class="mobile-wallet-adapter-embedded-modal-subtitle">
    Visit site settings in the address bar and allow "Apps on Device".
</div>

<div class="mobile-wallet-adapter-embedded-modal-divider"><hr></div>
<div class="mobile-wallet-adapter-embedded-modal-footer">
    <div class="mobile-wallet-adapter-embedded-modal-details">
        <!-- Clickable header (label associated with the checkbox) -->
      	<label for="collapsible-1" class="mobile-wallet-adapter-embedded-modal-details-collapsible-header">
            <!-- Hidden checkbox to track state -->
            <input type="checkbox" id="collapsible-1" class="mobile-wallet-adapter-embedded-modal-details-collapsible-input">
            <span class="mobile-wallet-adapter-embedded-modal-details-collapsible-header-label">
              See details
            </span>
            <svg class="mobile-wallet-adapter-embedded-modal-details-collapsible-header-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0_147_1382" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" fill="#D9D9D9"/>
              </mask>
              <g mask="url(#mask0_147_1382)">
                <path d="M11.9999 17.0811C11.8506 17.0811 11.7087 17.0563 11.5741 17.0067C11.4395 16.957 11.3162 16.8762 11.2042 16.7643L6.57924 12.1393C6.36801 11.9281 6.26656 11.667 6.27489 11.3561C6.28322 11.0453 6.39301 10.7842 6.60424 10.573C6.81547 10.3618 7.08069 10.2561 7.39989 10.2561C7.71909 10.2561 7.9843 10.3618 8.19554 10.573L11.9999 14.3773L15.8292 10.548C16.0405 10.3368 16.3015 10.2353 16.6124 10.2436C16.9233 10.252 17.1843 10.3618 17.3955 10.573C17.6068 10.7842 17.7124 11.0494 17.7124 11.3686C17.7124 11.6878 17.6068 11.9531 17.3955 12.1643L12.7955 16.7643C12.6836 16.8762 12.5603 16.957 12.4257 17.0067C12.2911 17.0563 12.1492 17.0811 11.9999 17.0811Z" fill="black"/>
              </g>
            </svg>
      	</label>
        
        <!-- Content to show/hide -->
        <ul class="mobile-wallet-adapter-embedded-modal-details-collapsible-content">
            <li>{{PERMISSION_INSTRUCTION_DETAIL}}</li>
            <li>Allow "Apps on Device"</li>
        </ul>
    </div>
</div>
<div>
    <button data-modal-action id="mobile-wallet-adapter-launch-action" class="mobile-wallet-adapter-embedded-modal-launch-action">
        Got it
    </button>
</div>
`;
const css$2 = `
.mobile-wallet-adapter-embedded-modal-close {
    display: none;
}
.mobile-wallet-adapter-embedded-modal-content {
    text-align: center;
}
.mobile-wallet-adapter-embedded-modal-header {
    margin: 18px auto 30px auto;
    color: #7D9093;
    font-size: 1.0em;
    font-weight: 500;
}
.mobile-wallet-adapter-embedded-modal-title {
    margin: 18px 100px auto 100px;
    color: #000000;
    font-size: 2.75em;
    font-weight: 600;
}
.mobile-wallet-adapter-embedded-modal-subtitle {
    margin: 12px 60px 30px 60px;
    color: #7D9093;
    font-size: 1.25em;
    font-weight: 400;
}
.mobile-wallet-adapter-embedded-modal-details-collapsible-header {
    display: flex;
    flex-direction: row;
  	justify-content: space-between;
    margin: 10px auto 10px auto;
    color: #000000;
    font-size: 1.5em;
    font-weight: 600;
    cursor: pointer; /* Show pointer on hover */
    transition: background 0.2s ease; /* Smooth background change */
}
.mobile-wallet-adapter-embedded-modal-details-collapsible-header-icon {
  	transition: rotate 0.3s ease;
}
.mobile-wallet-adapter-embedded-modal-details-collapsible-input {
  	display: none; /* Hide the checkbox */
}
.mobile-wallet-adapter-embedded-modal-details-collapsible-content {
    margin: 0px auto 40px auto;
    max-height: 0px; /* Collapse content */
    overflow: hidden; /* Hide overflow when collapsed */
    transition: max-height 0.3s ease; /* Smooth transition */
}
.mobile-wallet-adapter-embedded-modal-details-collapsible-content li {
    margin: 20px auto;
    color: #000000;
    font-size: 1.25em;
    font-weight: 400;
    text-align: left;
}
/* When checkbox is checked, show content */
.mobile-wallet-adapter-embedded-modal-details-collapsible-header:has(> input:checked) ~ .mobile-wallet-adapter-embedded-modal-details-collapsible-content {
  	max-height: 300px;
}
.mobile-wallet-adapter-embedded-modal-details-collapsible-header:has(> input:checked) > .mobile-wallet-adapter-embedded-modal-details-collapsible-header-icon {
  	rotate: 180deg;
}
.mobile-wallet-adapter-embedded-modal-launch-action {
    display: block;
    width: 100%;
    height: 56px;
    /*margin-top: 40px;*/
    font-size: 1.25em;
    /*line-height: 24px;*/
    /*letter-spacing: -1%;*/
    background: #000000;
    color: #FFFFFF;
    border-radius: 18px;
}
/* Smaller screens */
@media all and (max-width: 600px) {
    .mobile-wallet-adapter-embedded-modal-title {
        font-size: 1.75em;
        margin-right: 12px;
        margin-left: 12px;
    }
    .mobile-wallet-adapter-embedded-modal-subtitle {
        margin-right: 12px;
        margin-left: 12px;
    }
}
`;
//#endregion
//#region src/embedded-modal/loopbackPermissionModal.ts
var LoopbackPermissionModal = class extends EmbeddedModal {
	contentStyles = css$1;
	contentHtml = ErrorDialogHtml$1;
	async init() {
		super.init();
		this.#prepareLaunchAction();
	}
	#prepareLaunchAction() {
		const launchButton = this.dom?.getElementById("mobile-wallet-adapter-launch-action");
		const listener = async () => {
			launchButton?.removeEventListener("click", listener);
			try {
				await fetch("http://localhost");
			} catch {}
			this.close();
		};
		launchButton?.addEventListener("click", listener);
	}
};
const ErrorDialogHtml$1 = `
<div class="mobile-wallet-adapter-embedded-modal-title">Allow connections to your wallet</div>
<div id="mobile-wallet-adapter-local-launch-message" class="mobile-wallet-adapter-embedded-modal-subtitle">
    Tap "Allow" on the next screen
</div>
<svg class="mobile-wallet-adapter-embedded-modal-permission-prompt-mock" xmlns="http://www.w3.org/2000/svg" width="281" height="83" viewBox="0 0 281 83" fill="none">
    <rect width="281" height="83" rx="22" fill="#F0F3F5"/>
    <path d="M254.194 64L252.626 56.657H254.047L254.866 61.452L254.985 62.278H255.02L255.146 61.452L255.993 57.497H257.4L258.254 61.431L258.373 62.278H258.415L258.534 61.431L259.346 56.657H260.718L259.143 64H257.673L256.826 59.961L256.693 59.093H256.651L256.511 59.961L255.664 64H254.194Z" fill="black"/>
    <path d="M248.837 64.231C248.147 64.231 247.54 64.07 247.017 63.748C246.495 63.426 246.086 62.978 245.792 62.404C245.498 61.83 245.351 61.1673 245.351 60.416V60.241C245.351 59.4897 245.498 58.827 245.792 58.253C246.086 57.679 246.495 57.2333 247.017 56.916C247.54 56.594 248.147 56.433 248.837 56.433C249.528 56.433 250.135 56.594 250.657 56.916C251.18 57.2333 251.588 57.679 251.882 58.253C252.176 58.827 252.323 59.4897 252.323 60.241V60.416C252.323 61.1673 252.176 61.83 251.882 62.404C251.588 62.978 251.18 63.426 250.657 63.748C250.135 64.07 249.528 64.231 248.837 64.231ZM248.837 62.824C249.43 62.824 249.897 62.607 250.237 62.173C250.583 61.7343 250.755 61.1417 250.755 60.395V60.262C250.755 59.5107 250.583 58.918 250.237 58.484C249.897 58.05 249.43 57.833 248.837 57.833C248.249 57.833 247.783 58.05 247.437 58.484C247.092 58.918 246.919 59.5107 246.919 60.262V60.395C246.919 61.1417 247.092 61.7343 247.437 62.173C247.783 62.607 248.249 62.824 248.837 62.824Z" fill="black"/>
    <path d="M242.298 64.231C241.467 64.231 240.814 63.993 240.338 63.517C239.866 63.0364 239.631 62.3737 239.631 61.529V53.78H241.178V61.389C241.178 62.3317 241.591 62.803 242.417 62.803C242.65 62.803 242.865 62.7587 243.061 62.67C243.257 62.5814 243.464 62.4367 243.684 62.236L244.538 63.377C244.225 63.6664 243.884 63.881 243.516 64.021C243.152 64.161 242.746 64.231 242.298 64.231ZM237.51 55.061V53.78H240.611V55.061H237.51Z" fill="black"/>
    <path d="M234.463 64.231C233.633 64.231 232.979 63.993 232.503 63.517C232.032 63.0364 231.796 62.3737 231.796 61.529V53.78H233.343V61.389C233.343 62.3317 233.756 62.803 234.582 62.803C234.816 62.803 235.03 62.7587 235.226 62.67C235.422 62.5814 235.63 62.4367 235.849 62.236L236.703 63.377C236.391 63.6664 236.05 63.881 235.681 64.021C235.317 64.161 234.911 64.231 234.463 64.231ZM229.675 55.061V53.78H232.776V55.061H229.675Z" fill="black"/>
    <path d="M221.442 64L224.557 53.976H226.132L229.233 64H227.581L225.642 56.972L225.341 55.761H225.299L225.005 56.972L223.073 64H221.442ZM222.835 61.634L223.255 60.29H227.371L227.805 61.634H222.835Z" fill="black"/>
    <path d="M178.261 64L175.034 60.066V60.024L178.121 56.657H180.011L176.504 60.423V59.632L180.165 64H178.261ZM173.543 64V53.78H175.097V64H173.543Z" fill="#7D9093" fill-opacity="0.5"/>
    <path d="M169.306 64.224C168.588 64.224 167.958 64.0653 167.416 63.748C166.88 63.426 166.462 62.9803 166.163 62.411C165.865 61.837 165.715 61.1673 165.715 60.402V60.248C165.715 59.4873 165.862 58.8223 166.156 58.253C166.45 57.679 166.863 57.2333 167.395 56.916C167.927 56.594 168.546 56.433 169.25 56.433C169.978 56.433 170.59 56.6056 171.084 56.951C171.579 57.2917 171.955 57.777 172.211 58.407L170.874 58.995C170.72 58.6123 170.508 58.323 170.237 58.127C169.967 57.9263 169.633 57.826 169.236 57.826C168.63 57.826 168.149 58.0383 167.794 58.463C167.444 58.883 167.269 59.4616 167.269 60.199V60.465C167.269 61.1837 167.454 61.7577 167.822 62.187C168.196 62.6163 168.69 62.831 169.306 62.831C169.712 62.831 170.06 62.733 170.349 62.537C170.639 62.341 170.877 62.0423 171.063 61.641L172.379 62.285C172.188 62.6957 171.941 63.0457 171.637 63.335C171.334 63.6243 170.986 63.846 170.594 64C170.202 64.1493 169.773 64.224 169.306 64.224Z" fill="#7D9093" fill-opacity="0.5"/>
    <path d="M161.003 64.231C160.312 64.231 159.706 64.07 159.183 63.748C158.66 63.426 158.252 62.978 157.958 62.404C157.664 61.83 157.517 61.1673 157.517 60.416V60.241C157.517 59.4897 157.664 58.827 157.958 58.253C158.252 57.679 158.66 57.2333 159.183 56.916C159.706 56.594 160.312 56.433 161.003 56.433C161.694 56.433 162.3 56.594 162.823 56.916C163.346 57.2333 163.754 57.679 164.048 58.253C164.342 58.827 164.489 59.4897 164.489 60.241V60.416C164.489 61.1673 164.342 61.83 164.048 62.404C163.754 62.978 163.346 63.426 162.823 63.748C162.3 64.07 161.694 64.231 161.003 64.231ZM161.003 62.824C161.596 62.824 162.062 62.607 162.403 62.173C162.748 61.7343 162.921 61.1417 162.921 60.395V60.262C162.921 59.5107 162.748 58.918 162.403 58.484C162.062 58.05 161.596 57.833 161.003 57.833C160.415 57.833 159.948 58.05 159.603 58.484C159.258 58.918 159.085 59.5107 159.085 60.262V60.395C159.085 61.1417 159.258 61.7343 159.603 62.173C159.948 62.607 160.415 62.824 161.003 62.824Z" fill="#7D9093" fill-opacity="0.5"/>
    <path d="M154.463 64.231C153.633 64.231 152.979 63.993 152.503 63.517C152.032 63.0364 151.796 62.3737 151.796 61.529V53.78H153.343V61.389C153.343 62.3317 153.756 62.803 154.582 62.803C154.816 62.803 155.03 62.7587 155.226 62.67C155.422 62.5814 155.63 62.4367 155.849 62.236L156.703 63.377C156.391 63.6664 156.05 63.881 155.681 64.021C155.317 64.161 154.911 64.231 154.463 64.231ZM149.675 55.061V53.78H152.776V55.061H149.675Z" fill="#7D9093" fill-opacity="0.5"/>
    <path d="M142.24 64V53.976H145.544C146.421 53.976 147.112 54.1953 147.616 54.634C148.12 55.0726 148.372 55.6583 148.372 56.391V56.566C148.372 57.0886 148.246 57.5366 147.994 57.91C147.742 58.2833 147.38 58.5586 146.909 58.736V58.792C147.492 58.9226 147.947 59.2003 148.274 59.625C148.605 60.045 148.771 60.5606 148.771 61.172V61.361C148.771 61.893 148.645 62.3573 148.393 62.754C148.145 63.1506 147.795 63.4586 147.343 63.678C146.895 63.8926 146.365 64 145.754 64H142.24ZM143.794 62.656H145.572C146.085 62.656 146.482 62.5253 146.762 62.264C147.042 62.0026 147.182 61.6293 147.182 61.144V60.99C147.182 60.5046 147.037 60.1313 146.748 59.87C146.463 59.604 146.05 59.471 145.509 59.471H143.36V58.183H145.32C145.791 58.183 146.153 58.064 146.405 57.826C146.657 57.588 146.783 57.2496 146.783 56.811V56.685C146.783 56.2416 146.657 55.9033 146.405 55.67C146.157 55.4366 145.796 55.32 145.32 55.32H143.794V62.656Z" fill="#7D9093" fill-opacity="0.5"/>
    <rect x="18" y="17" width="246" height="7" rx="3.5" fill="#7D9093" fill-opacity="0.26"/>
    <rect x="18" y="33" width="82" height="7" rx="3.5" fill="#7D9093" fill-opacity="0.26"/>
</svg>
<div>
    <button data-modal-action id="mobile-wallet-adapter-launch-action" class="mobile-wallet-adapter-embedded-modal-launch-action">
        Continue to Allow
    </button>
</div>
`;
const css$1 = `
.mobile-wallet-adapter-embedded-modal-close {
    display: none;
}
.mobile-wallet-adapter-embedded-modal-content {
    text-align: center;
}
.mobile-wallet-adapter-embedded-modal-title {
    margin: 18px 100px auto 100px;
    color: #000000;
    font-size: 2.75em;
    font-weight: 600;
}
.mobile-wallet-adapter-embedded-modal-subtitle {
    margin: 20px 60px 40px 60px;
    color: #7D9093;
    font-size: 1.25em;
    font-weight: 400;
}
.mobile-wallet-adapter-embedded-modal-permission-prompt-mock {
    width: 90%;
    height: auto;
    margin: 0 auto 30px auto;
    display: block;
}
.mobile-wallet-adapter-embedded-modal-launch-action {
    display: block;
    width: 100%;
    height: 56px;
    font-size: 1.25em;
    background: #000000;
    color: #FFFFFF;
    border-radius: 18px;
}
/* Smaller screens */
@media all and (max-width: 600px) {
    .mobile-wallet-adapter-embedded-modal-title {
        font-size: 1.5em;
        margin-right: 12px;
        margin-left: 12px;
    }
    .mobile-wallet-adapter-embedded-modal-subtitle {
        margin-right: 12px;
        margin-left: 12px;
    }
}
`;
//#endregion
//#region src/getIsSupported.ts
function getIsLocalAssociationSupported() {
	return typeof window !== "undefined" && window.isSecureContext && typeof document !== "undefined" && /android/i.test(navigator.userAgent);
}
function getIsRemoteAssociationSupported() {
	return typeof window !== "undefined" && window.isSecureContext && typeof document !== "undefined" && !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
function isWebView(userAgentString) {
	return /(WebView|Version\/.+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+)|; wv\).+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+))/i.test(userAgentString);
}
function isSolanaMobileWebShell(userAgentString) {
	return userAgentString.includes("Solana Mobile Web Shell");
}
function getIsPwaLaunchedAsApp() {
	const isAndroidTwa = typeof document !== "undefined" && document.referrer.startsWith("android-app://");
	if (typeof window == "undefined") return isAndroidTwa;
	const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
	const isFullscreen = window.matchMedia("(display-mode: fullscreen)").matches;
	const isMinimalUI = window.matchMedia("(display-mode: minimal-ui)").matches;
	return isAndroidTwa || isStandalone || isFullscreen || isMinimalUI;
}
async function checkLocalNetworkAccessPermission() {
	if (typeof navigator !== "undefined" && isSolanaMobileWebShell(navigator.userAgent)) return;
	try {
		const lnaPermission = await navigator.permissions.query({ name: "loopback-network" });
		if (lnaPermission.state === "granted") return;
		else if (lnaPermission.state === "denied") {
			const modal = new LoopbackPermissionBlockedModal();
			modal.init();
			modal.open();
			throw new SolanaMobileWalletAdapterError(SolanaMobileWalletAdapterErrorCode.ERROR_LOOPBACK_ACCESS_BLOCKED, "Local Network Access permission denied");
		} else if (lnaPermission.state === "prompt") {
			const modal = new LoopbackPermissionModal();
			if (await new Promise((resolve, reject) => {
				modal.addEventListener("close", (event) => {
					if (event) reject(new SolanaMobileWalletAdapterError(SolanaMobileWalletAdapterErrorCode.ERROR_ASSOCIATION_CANCELLED, "Wallet connection cancelled by user", { event }));
				});
				lnaPermission.onchange = () => {
					lnaPermission.onchange = null;
					resolve(lnaPermission.state);
				};
				modal.init();
				modal.open();
			}) === "granted") {
				const modal = new LocalConnectionModal();
				await new Promise((resolve, reject) => {
					modal.addEventListener("close", (event) => {
						if (event) reject(new SolanaMobileWalletAdapterError(SolanaMobileWalletAdapterErrorCode.ERROR_ASSOCIATION_CANCELLED, "Wallet connection cancelled by user", { event }));
					});
					modal.initWithCallback(async () => {
						resolve(true);
					});
					modal.open();
				});
				return;
			} else return await checkLocalNetworkAccessPermission();
		}
		throw new SolanaMobileWalletAdapterError(SolanaMobileWalletAdapterErrorCode.ERROR_LOOPBACK_ACCESS_BLOCKED, "Local Network Access permission unknown");
	} catch (e) {
		if (e instanceof TypeError && (e.message.includes("loopback-network") || e.message.includes("local-network-access"))) return;
		if (e instanceof SolanaMobileWalletAdapterError) throw e;
		throw new SolanaMobileWalletAdapterError(SolanaMobileWalletAdapterErrorCode.ERROR_LOOPBACK_ACCESS_BLOCKED, e instanceof Error ? e.message : "Local Network Access permission unknown");
	}
}
//#endregion
//#region src/icon.ts
const icon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03IDIuNUgxN0MxNy44Mjg0IDIuNSAxOC41IDMuMTcxNTcgMTguNSA0VjIwQzE4LjUgMjAuODI4NCAxNy44Mjg0IDIxLjUgMTcgMjEuNUg3QzYuMTcxNTcgMjEuNSA1LjUgMjAuODI4NCA1LjUgMjBWNEM1LjUgMy4xNzE1NyA2LjE3MTU3IDIuNSA3IDIuNVpNMyA0QzMgMS43OTA4NiA0Ljc5MDg2IDAgNyAwSDE3QzE5LjIwOTEgMCAyMSAxLjc5MDg2IDIxIDRWMjBDMjEgMjIuMjA5MSAxOS4yMDkxIDI0IDE3IDI0SDdDNC43OTA4NiAyNCAzIDIyLjIwOTEgMyAyMFY0Wk0xMSA0LjYxNTM4QzEwLjQ0NzcgNC42MTUzOCAxMCA1LjA2MzEgMTAgNS42MTUzOFY2LjM4NDYyQzEwIDYuOTM2OSAxMC40NDc3IDcuMzg0NjIgMTEgNy4zODQ2MkgxM0MxMy41NTIzIDcuMzg0NjIgMTQgNi45MzY5IDE0IDYuMzg0NjJWNS42MTUzOEMxNCA1LjA2MzEgMTMuNTUyMyA0LjYxNTM4IDEzIDQuNjE1MzhIMTFaIiBmaWxsPSIjRENCOEZGIi8+Cjwvc3ZnPgo=";
//#endregion
//#region src/wallet.ts
const SolanaMobileWalletAdapterWalletName = "Mobile Wallet Adapter";
const SolanaMobileWalletAdapterRemoteWalletName = "Remote Mobile Wallet Adapter";
const SIGNATURE_LENGTH_IN_BYTES = 64;
const DEFAULT_FEATURES = [
	SolanaSignAndSendTransaction,
	SolanaSignTransaction,
	SolanaSignMessage,
	SolanaSignIn
];
const WALLET_ASSOCIATION_TIMEOUT = 3e4;
function getErrorMessage(error) {
	return error instanceof Error ? error.message : "Unknown error";
}
var LocalSolanaMobileWalletAdapterWallet = class {
	#listeners = {};
	#version = "1.0.0";
	#name = SolanaMobileWalletAdapterWalletName;
	#url = "https://solanamobile.com/wallets";
	#icon = icon;
	#appIdentity;
	#authorization;
	#authorizationCache;
	#connecting = false;
	/**
	* Every time the connection is recycled in some way (eg. `disconnect()` is called)
	* increment this and use it to make sure that `transact` calls from the previous
	* 'generation' don't continue to do work and throw exceptions.
	*/
	#connectionGeneration = 0;
	#chains = [];
	#chainSelector;
	#optionalFeatures;
	#onWalletNotFound;
	get version() {
		return this.#version;
	}
	get name() {
		return this.#name;
	}
	get url() {
		return this.#url;
	}
	get icon() {
		return this.#icon;
	}
	get chains() {
		return this.#chains;
	}
	get features() {
		return {
			[StandardConnect]: {
				version: "1.0.0",
				connect: this.#connect
			},
			[StandardDisconnect]: {
				version: "1.0.0",
				disconnect: this.#disconnect
			},
			[StandardEvents]: {
				version: "1.0.0",
				on: this.#on
			},
			[SolanaSignMessage]: {
				version: "1.0.0",
				signMessage: this.#signMessage
			},
			[SolanaSignIn]: {
				version: "1.0.0",
				signIn: this.#signIn
			},
			...this.#optionalFeatures
		};
	}
	get accounts() {
		return this.#authorization?.accounts ?? [];
	}
	constructor(config) {
		this.#authorizationCache = config.authorizationCache;
		this.#appIdentity = config.appIdentity;
		this.#chains = config.chains;
		this.#chainSelector = config.chainSelector;
		this.#onWalletNotFound = config.onWalletNotFound;
		this.#optionalFeatures = {
			[SolanaSignAndSendTransaction]: {
				version: "1.0.0",
				supportedTransactionVersions: ["legacy", 0],
				signAndSendTransaction: this.#signAndSendTransaction
			},
			[SolanaSignTransaction]: {
				version: "1.0.0",
				supportedTransactionVersions: ["legacy", 0],
				signTransaction: this.#signTransaction
			}
		};
	}
	get connected() {
		return !!this.#authorization;
	}
	get isAuthorized() {
		return !!this.#authorization;
	}
	get currentAuthorization() {
		return this.#authorization;
	}
	get cachedAuthorizationResult() {
		return this.#authorizationCache.get();
	}
	#on = (event, listener) => {
		this.#listeners[event]?.push(listener) || (this.#listeners[event] = [listener]);
		return () => this.#off(event, listener);
	};
	#emit(event, ...args) {
		this.#listeners[event]?.forEach((listener) => listener.apply(null, args));
	}
	#off(event, listener) {
		this.#listeners[event] = this.#listeners[event]?.filter((existingListener) => listener !== existingListener);
	}
	#connect = async ({ silent } = {}) => {
		if (this.#connecting || this.connected) return { accounts: this.accounts };
		this.#connecting = true;
		try {
			if (silent) {
				const cachedAuthorization = await this.#authorizationCache.get();
				if (cachedAuthorization) {
					await this.#handleWalletCapabilitiesResult(cachedAuthorization.capabilities);
					await this.#handleAuthorizationResult(cachedAuthorization);
				} else return { accounts: this.accounts };
			} else await this.#performAuthorization();
		} catch (e) {
			throw new Error(getErrorMessage(e), { cause: e });
		} finally {
			this.#connecting = false;
		}
		return { accounts: this.accounts };
	};
	#performAuthorization = async (signInPayload) => {
		try {
			const cachedAuthorizationResult = await this.#authorizationCache.get();
			if (cachedAuthorizationResult) {
				this.#handleAuthorizationResult(cachedAuthorizationResult);
				return cachedAuthorizationResult;
			}
			const selectedChain = await this.#chainSelector.select(this.#chains);
			return await this.#transact(async (wallet) => {
				const [capabilities, mwaAuthorizationResult] = await Promise.all([wallet.getCapabilities(), wallet.authorize({
					chain: selectedChain,
					identity: this.#appIdentity,
					sign_in_payload: signInPayload
				})]);
				const accounts = this.#accountsToWalletStandardAccounts(mwaAuthorizationResult.accounts);
				const authorization = {
					...mwaAuthorizationResult,
					accounts,
					chain: selectedChain,
					capabilities
				};
				Promise.all([
					this.#handleWalletCapabilitiesResult(capabilities),
					this.#authorizationCache.set(authorization),
					this.#handleAuthorizationResult(authorization)
				]);
				return authorization;
			});
		} catch (e) {
			throw new Error(getErrorMessage(e), { cause: e });
		}
	};
	#handleAuthorizationResult = async (authorization) => {
		const didPublicKeysChange = this.#authorization == null || this.#authorization?.accounts.length !== authorization.accounts.length || this.#authorization.accounts.some((account, ii) => account.address !== authorization.accounts[ii].address);
		this.#authorization = authorization;
		if (didPublicKeysChange) this.#emit("change", { accounts: this.accounts });
	};
	#handleWalletCapabilitiesResult = async (capabilities) => {
		const supportsSignTransaction = capabilities.features.includes("solana:signTransactions");
		const supportsSignAndSendTransaction = capabilities.supports_sign_and_send_transactions;
		const didCapabilitiesChange = SolanaSignAndSendTransaction in this.features !== supportsSignAndSendTransaction || SolanaSignTransaction in this.features !== supportsSignTransaction;
		this.#optionalFeatures = {
			...(supportsSignAndSendTransaction || !supportsSignAndSendTransaction && !supportsSignTransaction) && { [SolanaSignAndSendTransaction]: {
				version: "1.0.0",
				supportedTransactionVersions: ["legacy", 0],
				signAndSendTransaction: this.#signAndSendTransaction
			} },
			...supportsSignTransaction && { [SolanaSignTransaction]: {
				version: "1.0.0",
				supportedTransactionVersions: ["legacy", 0],
				signTransaction: this.#signTransaction
			} }
		};
		if (didCapabilitiesChange) this.#emit("change", { features: this.features });
	};
	#performReauthorization = async (wallet, authToken, chain) => {
		try {
			const [capabilities, mwaAuthorizationResult] = await Promise.all([this.#authorization?.capabilities ?? await wallet.getCapabilities(), wallet.authorize({
				auth_token: authToken,
				identity: this.#appIdentity,
				chain
			})]);
			const accounts = this.#accountsToWalletStandardAccounts(mwaAuthorizationResult.accounts);
			const authorization = {
				...mwaAuthorizationResult,
				accounts,
				chain,
				capabilities
			};
			Promise.all([this.#authorizationCache.set(authorization), this.#handleAuthorizationResult(authorization)]);
		} catch (e) {
			this.#disconnect();
			throw new Error(getErrorMessage(e), { cause: e });
		}
	};
	#disconnect = async () => {
		this.#authorizationCache.clear();
		this.#connecting = false;
		this.#connectionGeneration++;
		this.#authorization = void 0;
		this.#emit("change", { accounts: this.accounts });
	};
	#transact = async (callback) => {
		const walletUriBase = this.#authorization?.wallet_uri_base;
		const config = walletUriBase ? { baseUri: walletUriBase } : void 0;
		const currentConnectionGeneration = this.#connectionGeneration;
		const loadingSpinner = new EmbeddedLoadingSpinner();
		try {
			let associating = true;
			let timeout = void 0;
			const result = await Promise.race([checkLocalNetworkAccessPermission().then(async () => {
				loadingSpinner.init();
				const { wallet, close } = await startScenario(config);
				associating = false;
				loadingSpinner.addEventListener("close", (event) => {
					if (event) close();
				});
				loadingSpinner.open();
				const result = await callback(await wallet);
				loadingSpinner.close();
				close();
				return result;
			}), new Promise((_, reject) => {
				timeout = setTimeout(() => {
					if (associating) reject(new SolanaMobileWalletAdapterError(SolanaMobileWalletAdapterErrorCode.ERROR_ASSOCIATION_CANCELLED, "Wallet connection timed out", { event: void 0 }));
				}, WALLET_ASSOCIATION_TIMEOUT);
			})]);
			clearTimeout(timeout);
			return result;
		} catch (e) {
			loadingSpinner.close();
			if (this.#connectionGeneration !== currentConnectionGeneration) await new Promise(() => {});
			if (e instanceof Error && e.name === "SolanaMobileWalletAdapterError" && e.code === "ERROR_WALLET_NOT_FOUND") await this.#onWalletNotFound(this);
			throw e;
		}
	};
	#assertIsAuthorized = () => {
		if (!this.#authorization) throw new Error("Wallet not connected");
		return {
			authToken: this.#authorization.auth_token,
			chain: this.#authorization.chain
		};
	};
	#accountsToWalletStandardAccounts = (accounts) => {
		return accounts.map((account) => {
			const publicKey = toUint8Array(account.address);
			return {
				address: base58.encode(publicKey),
				publicKey,
				label: account.label,
				icon: account.icon,
				chains: account.chains ?? this.#chains,
				features: account.features ?? DEFAULT_FEATURES
			};
		});
	};
	#performSignTransactions = async (transactions) => {
		const { authToken, chain } = this.#assertIsAuthorized();
		try {
			const base64Transactions = transactions.map((tx) => {
				return fromUint8Array(tx);
			});
			return await this.#transact(async (wallet) => {
				await this.#performReauthorization(wallet, authToken, chain);
				return (await wallet.signTransactions({ payloads: base64Transactions })).signed_payloads.map(toUint8Array);
			});
		} catch (e) {
			throw new Error(getErrorMessage(e), { cause: e });
		}
	};
	#performSignAndSendTransaction = async (transaction, options) => {
		const { authToken, chain } = this.#assertIsAuthorized();
		try {
			return await this.#transact(async (wallet) => {
				const [capabilities] = await Promise.all([wallet.getCapabilities(), this.#performReauthorization(wallet, authToken, chain)]);
				if (capabilities.supports_sign_and_send_transactions) {
					const base64Transaction = fromUint8Array(transaction);
					return (await wallet.signAndSendTransactions({
						...options,
						payloads: [base64Transaction]
					})).signatures.map(toUint8Array)[0];
				} else throw new Error("connected wallet does not support signAndSendTransaction");
			});
		} catch (e) {
			throw new Error(getErrorMessage(e), { cause: e });
		}
	};
	#signAndSendTransaction = async (...inputs) => {
		const outputs = [];
		for (const input of inputs) {
			const signature = await this.#performSignAndSendTransaction(input.transaction, input.options);
			outputs.push({ signature });
		}
		return outputs;
	};
	#signTransaction = async (...inputs) => {
		return (await this.#performSignTransactions(inputs.map(({ transaction }) => transaction))).map((signedTransaction) => {
			return { signedTransaction };
		});
	};
	#signMessage = async (...inputs) => {
		const { authToken, chain } = this.#assertIsAuthorized();
		const addresses = inputs.map(({ account }) => fromUint8Array(new Uint8Array(account.publicKey)));
		const messages = inputs.map(({ message }) => fromUint8Array(message));
		try {
			return await this.#transact(async (wallet) => {
				await this.#performReauthorization(wallet, authToken, chain);
				return (await wallet.signMessages({
					addresses,
					payloads: messages
				})).signed_payloads.map(toUint8Array).map((signedMessage) => {
					return {
						signedMessage,
						signature: signedMessage.slice(-SIGNATURE_LENGTH_IN_BYTES)
					};
				});
			});
		} catch (e) {
			throw new Error(getErrorMessage(e), { cause: e });
		}
	};
	#signIn = async (...inputs) => {
		const outputs = [];
		if (inputs.length > 1) for (const input of inputs) outputs.push(await this.#performSignIn(input));
		else return [await this.#performSignIn(inputs[0])];
		return outputs;
	};
	#performSignIn = async (input) => {
		this.#connecting = true;
		try {
			const authorizationResult = await this.#performAuthorization({
				...input,
				domain: input?.domain ?? window.location.host
			});
			if (!authorizationResult.sign_in_result) throw new Error("Sign in failed, no sign in result returned by wallet");
			const signedInAddress = authorizationResult.sign_in_result.address;
			const signedInAccount = authorizationResult.accounts.find((acc) => acc.address == signedInAddress);
			return {
				account: {
					...signedInAccount ?? { address: base58.encode(toUint8Array(signedInAddress)) },
					publicKey: toUint8Array(signedInAddress),
					chains: signedInAccount?.chains ?? this.#chains,
					features: signedInAccount?.features ?? authorizationResult.capabilities.features
				},
				signedMessage: toUint8Array(authorizationResult.sign_in_result.signed_message),
				signature: toUint8Array(authorizationResult.sign_in_result.signature)
			};
		} catch (e) {
			throw new Error(getErrorMessage(e), { cause: e });
		} finally {
			this.#connecting = false;
		}
	};
};
var RemoteSolanaMobileWalletAdapterWallet = class {
	#listeners = {};
	#version = "1.0.0";
	#name = SolanaMobileWalletAdapterRemoteWalletName;
	#url = "https://solanamobile.com/wallets";
	#icon = icon;
	#appIdentity;
	#authorization;
	#authorizationCache;
	#connecting = false;
	/**
	* Every time the connection is recycled in some way (eg. `disconnect()` is called)
	* increment this and use it to make sure that `transact` calls from the previous
	* 'generation' don't continue to do work and throw exceptions.
	*/
	#connectionGeneration = 0;
	#chains = [];
	#chainSelector;
	#optionalFeatures;
	#onWalletNotFound;
	#hostAuthority;
	#session;
	get version() {
		return this.#version;
	}
	get name() {
		return this.#name;
	}
	get url() {
		return this.#url;
	}
	get icon() {
		return this.#icon;
	}
	get chains() {
		return this.#chains;
	}
	get features() {
		return {
			[StandardConnect]: {
				version: "1.0.0",
				connect: this.#connect
			},
			[StandardDisconnect]: {
				version: "1.0.0",
				disconnect: this.#disconnect
			},
			[StandardEvents]: {
				version: "1.0.0",
				on: this.#on
			},
			[SolanaSignMessage]: {
				version: "1.0.0",
				signMessage: this.#signMessage
			},
			[SolanaSignIn]: {
				version: "1.0.0",
				signIn: this.#signIn
			},
			...this.#optionalFeatures
		};
	}
	get accounts() {
		return this.#authorization?.accounts ?? [];
	}
	constructor(config) {
		this.#authorizationCache = config.authorizationCache;
		this.#appIdentity = config.appIdentity;
		this.#chains = config.chains;
		this.#chainSelector = config.chainSelector;
		this.#hostAuthority = config.remoteHostAuthority;
		this.#onWalletNotFound = config.onWalletNotFound;
		this.#optionalFeatures = {
			[SolanaSignAndSendTransaction]: {
				version: "1.0.0",
				supportedTransactionVersions: ["legacy", 0],
				signAndSendTransaction: this.#signAndSendTransaction
			},
			[SolanaSignTransaction]: {
				version: "1.0.0",
				supportedTransactionVersions: ["legacy", 0],
				signTransaction: this.#signTransaction
			}
		};
	}
	get connected() {
		return !!this.#session && !!this.#authorization;
	}
	get isAuthorized() {
		return !!this.#authorization;
	}
	get currentAuthorization() {
		return this.#authorization;
	}
	get cachedAuthorizationResult() {
		return this.#authorizationCache.get();
	}
	#on = (event, listener) => {
		this.#listeners[event]?.push(listener) || (this.#listeners[event] = [listener]);
		return () => this.#off(event, listener);
	};
	#emit(event, ...args) {
		this.#listeners[event]?.forEach((listener) => listener.apply(null, args));
	}
	#off(event, listener) {
		this.#listeners[event] = this.#listeners[event]?.filter((existingListener) => listener !== existingListener);
	}
	#connect = async (_input = {}) => {
		if (this.#connecting || this.connected) return { accounts: this.accounts };
		this.#connecting = true;
		try {
			await this.#performAuthorization();
		} catch (e) {
			throw new Error(getErrorMessage(e), { cause: e });
		} finally {
			this.#connecting = false;
		}
		return { accounts: this.accounts };
	};
	#performAuthorization = async (signInPayload) => {
		try {
			const cachedAuthorizationResult = await this.#authorizationCache.get();
			if (cachedAuthorizationResult) {
				this.#handleAuthorizationResult(cachedAuthorizationResult);
				return cachedAuthorizationResult;
			}
			if (this.#session) this.#session = void 0;
			const selectedChain = await this.#chainSelector.select(this.#chains);
			return await this.#transact(async (wallet) => {
				const [capabilities, mwaAuthorizationResult] = await Promise.all([wallet.getCapabilities(), wallet.authorize({
					chain: selectedChain,
					identity: this.#appIdentity,
					sign_in_payload: signInPayload
				})]);
				const accounts = this.#accountsToWalletStandardAccounts(mwaAuthorizationResult.accounts);
				const authorizationResult = {
					...mwaAuthorizationResult,
					accounts,
					chain: selectedChain,
					capabilities
				};
				Promise.all([
					this.#handleWalletCapabilitiesResult(capabilities),
					this.#authorizationCache.set(authorizationResult),
					this.#handleAuthorizationResult(authorizationResult)
				]);
				return authorizationResult;
			});
		} catch (e) {
			throw new Error(getErrorMessage(e), { cause: e });
		}
	};
	#handleAuthorizationResult = async (authorization) => {
		const didPublicKeysChange = this.#authorization == null || this.#authorization?.accounts.length !== authorization.accounts.length || this.#authorization.accounts.some((account, ii) => account.address !== authorization.accounts[ii].address);
		this.#authorization = authorization;
		if (didPublicKeysChange) this.#emit("change", { accounts: this.accounts });
	};
	#handleWalletCapabilitiesResult = async (capabilities) => {
		const supportsSignTransaction = capabilities.features.includes("solana:signTransactions");
		const supportsSignAndSendTransaction = capabilities.supports_sign_and_send_transactions || capabilities.features.includes("solana:signAndSendTransaction");
		const didCapabilitiesChange = SolanaSignAndSendTransaction in this.features !== supportsSignAndSendTransaction || SolanaSignTransaction in this.features !== supportsSignTransaction;
		this.#optionalFeatures = {
			...supportsSignAndSendTransaction && { [SolanaSignAndSendTransaction]: {
				version: "1.0.0",
				supportedTransactionVersions: capabilities.supported_transaction_versions,
				signAndSendTransaction: this.#signAndSendTransaction
			} },
			...supportsSignTransaction && { [SolanaSignTransaction]: {
				version: "1.0.0",
				supportedTransactionVersions: capabilities.supported_transaction_versions,
				signTransaction: this.#signTransaction
			} }
		};
		if (didCapabilitiesChange) this.#emit("change", { features: this.features });
	};
	#performReauthorization = async (wallet, authToken, chain) => {
		try {
			const [capabilities, mwaAuthorizationResult] = await Promise.all([this.#authorization?.capabilities ?? await wallet.getCapabilities(), wallet.authorize({
				auth_token: authToken,
				identity: this.#appIdentity,
				chain
			})]);
			const accounts = this.#accountsToWalletStandardAccounts(mwaAuthorizationResult.accounts);
			const authorization = {
				...mwaAuthorizationResult,
				accounts,
				chain,
				capabilities
			};
			Promise.all([this.#authorizationCache.set(authorization), this.#handleAuthorizationResult(authorization)]);
		} catch (e) {
			this.#disconnect();
			throw new Error(getErrorMessage(e), { cause: e });
		}
	};
	#disconnect = async () => {
		this.#session?.close();
		this.#authorizationCache.clear();
		this.#connecting = false;
		this.#connectionGeneration++;
		this.#authorization = void 0;
		this.#session = void 0;
		this.#emit("change", { accounts: this.accounts });
	};
	#transact = async (callback) => {
		const walletUriBase = this.#authorization?.wallet_uri_base;
		const remoteConfig = {
			...walletUriBase ? { baseUri: walletUriBase } : void 0,
			remoteHostAuthority: this.#hostAuthority
		};
		const currentConnectionGeneration = this.#connectionGeneration;
		const modal = new RemoteConnectionModal();
		if (this.#session) return callback(this.#session.wallet);
		try {
			modal.init();
			modal.open();
			const { associationUrl, close, wallet } = await startRemoteScenario(remoteConfig);
			const removeCloseListener = modal.addEventListener("close", (event) => {
				if (event) close();
			});
			modal.populateQRCode(associationUrl.toString());
			this.#session = {
				close,
				wallet: await wallet
			};
			removeCloseListener();
			modal.close();
			return await callback(this.#session.wallet);
		} catch (e) {
			modal.close();
			if (this.#connectionGeneration !== currentConnectionGeneration) await new Promise(() => {});
			if (e instanceof Error && e.name === "SolanaMobileWalletAdapterError" && e.code === "ERROR_WALLET_NOT_FOUND") await this.#onWalletNotFound(this);
			throw e;
		}
	};
	#assertIsAuthorized = () => {
		if (!this.#authorization) throw new Error("Wallet not connected");
		return {
			authToken: this.#authorization.auth_token,
			chain: this.#authorization.chain
		};
	};
	#accountsToWalletStandardAccounts = (accounts) => {
		return accounts.map((account) => {
			const publicKey = toUint8Array(account.address);
			return {
				address: base58.encode(publicKey),
				publicKey,
				label: account.label,
				icon: account.icon,
				chains: account.chains ?? this.#chains,
				features: account.features ?? DEFAULT_FEATURES
			};
		});
	};
	#performSignTransactions = async (transactions) => {
		const { authToken, chain } = this.#assertIsAuthorized();
		try {
			return await this.#transact(async (wallet) => {
				await this.#performReauthorization(wallet, authToken, chain);
				return (await wallet.signTransactions({ payloads: transactions.map(fromUint8Array) })).signed_payloads.map(toUint8Array);
			});
		} catch (e) {
			throw new Error(getErrorMessage(e), { cause: e });
		}
	};
	#performSignAndSendTransaction = async (transaction, options) => {
		const { authToken, chain } = this.#assertIsAuthorized();
		try {
			return await this.#transact(async (wallet) => {
				const [capabilities] = await Promise.all([wallet.getCapabilities(), this.#performReauthorization(wallet, authToken, chain)]);
				if (capabilities.supports_sign_and_send_transactions) return (await wallet.signAndSendTransactions({
					...options,
					payloads: [fromUint8Array(transaction)]
				})).signatures.map(toUint8Array)[0];
				else throw new Error("connected wallet does not support signAndSendTransaction");
			});
		} catch (e) {
			throw new Error(getErrorMessage(e), { cause: e });
		}
	};
	#signAndSendTransaction = async (...inputs) => {
		const outputs = [];
		for (const input of inputs) {
			const signature = await this.#performSignAndSendTransaction(input.transaction, input.options);
			outputs.push({ signature });
		}
		return outputs;
	};
	#signTransaction = async (...inputs) => {
		return (await this.#performSignTransactions(inputs.map(({ transaction }) => transaction))).map((signedTransaction) => {
			return { signedTransaction };
		});
	};
	#signMessage = async (...inputs) => {
		const { authToken, chain } = this.#assertIsAuthorized();
		const addresses = inputs.map(({ account }) => fromUint8Array(new Uint8Array(account.publicKey)));
		const messages = inputs.map(({ message }) => fromUint8Array(message));
		try {
			return await this.#transact(async (wallet) => {
				await this.#performReauthorization(wallet, authToken, chain);
				return (await wallet.signMessages({
					addresses,
					payloads: messages
				})).signed_payloads.map(toUint8Array).map((signedMessage) => {
					return {
						signedMessage,
						signature: signedMessage.slice(-SIGNATURE_LENGTH_IN_BYTES)
					};
				});
			});
		} catch (e) {
			throw new Error(getErrorMessage(e), { cause: e });
		}
	};
	#signIn = async (...inputs) => {
		const outputs = [];
		if (inputs.length > 1) for (const input of inputs) outputs.push(await this.#performSignIn(input));
		else return [await this.#performSignIn(inputs[0])];
		return outputs;
	};
	#performSignIn = async (input) => {
		this.#connecting = true;
		try {
			const authorizationResult = await this.#performAuthorization({
				...input,
				domain: input?.domain ?? window.location.host
			});
			if (!authorizationResult.sign_in_result) throw new Error("Sign in failed, no sign in result returned by wallet");
			const signedInAddress = authorizationResult.sign_in_result.address;
			const signedInAccount = authorizationResult.accounts.find((acc) => acc.address == signedInAddress);
			return {
				account: {
					...signedInAccount ?? { address: base58.encode(toUint8Array(signedInAddress)) },
					publicKey: toUint8Array(signedInAddress),
					chains: signedInAccount?.chains ?? this.#chains,
					features: signedInAccount?.features ?? authorizationResult.capabilities.features
				},
				signedMessage: toUint8Array(authorizationResult.sign_in_result.signed_message),
				signature: toUint8Array(authorizationResult.sign_in_result.signature)
			};
		} catch (e) {
			throw new Error(getErrorMessage(e), { cause: e });
		} finally {
			this.#connecting = false;
		}
	};
};
//#endregion
//#region src/initialize.ts
function registerMwa(config) {
	if (typeof window === "undefined") {
		console.warn(`MWA not registered: no window object`);
		return;
	}
	if (!window.isSecureContext) {
		console.warn(`MWA not registered: secure context required (https)`);
		return;
	}
	const userAgent = navigator.userAgent;
	if (getIsLocalAssociationSupported() && (!isWebView(userAgent) || isSolanaMobileWebShell(userAgent))) registerWallet(new LocalSolanaMobileWalletAdapterWallet(config));
	else if (getIsRemoteAssociationSupported() && config.remoteHostAuthority !== void 0) registerWallet(new RemoteSolanaMobileWalletAdapterWallet({
		...config,
		remoteHostAuthority: config.remoteHostAuthority
	}));
}
//#endregion
//#region src/embedded-modal/errorModal.ts
const WALLET_NOT_FOUND_ERROR_MESSAGE = "To use mobile wallet adapter, you must have a compatible mobile wallet application installed on your device.";
const BROWSER_NOT_SUPPORTED_ERROR_MESSAGE = "This browser appears to be incompatible with mobile wallet adapter. Open this page in a compatible mobile browser app and try again.";
var ErrorModal = class extends EmbeddedModal {
	contentStyles = css;
	contentHtml = ErrorDialogHtml;
	initWithError(error) {
		super.init();
		this.populateError(error);
	}
	populateError(error) {
		const errorMessageElement = this.dom?.getElementById("mobile-wallet-adapter-error-message");
		const actionBtn = this.dom?.getElementById("mobile-wallet-adapter-error-action");
		if (errorMessageElement) {
			if (error.name === "SolanaMobileWalletAdapterError") switch (error.code) {
				case "ERROR_WALLET_NOT_FOUND":
					errorMessageElement.innerHTML = WALLET_NOT_FOUND_ERROR_MESSAGE;
					if (actionBtn) actionBtn.addEventListener("click", () => {
						window.location.href = "https://solanamobile.com/wallets";
					});
					return;
				case "ERROR_BROWSER_NOT_SUPPORTED":
					errorMessageElement.innerHTML = BROWSER_NOT_SUPPORTED_ERROR_MESSAGE;
					if (actionBtn) actionBtn.style.display = "none";
					return;
			}
			errorMessageElement.innerHTML = `An unexpected error occurred: ${error.message}`;
		} else console.log("Failed to locate error dialog element");
	}
};
const ErrorDialogHtml = `
<svg class="mobile-wallet-adapter-embedded-modal-error-icon" xmlns="http://www.w3.org/2000/svg" height="50px" viewBox="0 -960 960 960" width="50px" fill="#000000"><path d="M 280,-80 Q 197,-80 138.5,-138.5 80,-197 80,-280 80,-363 138.5,-421.5 197,-480 280,-480 q 83,0 141.5,58.5 58.5,58.5 58.5,141.5 0,83 -58.5,141.5 Q 363,-80 280,-80 Z M 824,-120 568,-376 Q 556,-389 542.5,-402.5 529,-416 516,-428 q 38,-24 61,-64 23,-40 23,-88 0,-75 -52.5,-127.5 Q 495,-760 420,-760 345,-760 292.5,-707.5 240,-655 240,-580 q 0,6 0.5,11.5 0.5,5.5 1.5,11.5 -18,2 -39.5,8 -21.5,6 -38.5,14 -2,-11 -3,-22 -1,-11 -1,-23 0,-109 75.5,-184.5 Q 311,-840 420,-840 q 109,0 184.5,75.5 75.5,75.5 75.5,184.5 0,43 -13.5,81.5 Q 653,-460 629,-428 l 251,252 z m -615,-61 71,-71 70,71 29,-28 -71,-71 71,-71 -28,-28 -71,71 -71,-71 -28,28 71,71 -71,71 z"/></svg>
<div class="mobile-wallet-adapter-embedded-modal-title">We can't find a wallet.</div>
<div id="mobile-wallet-adapter-error-message" class="mobile-wallet-adapter-embedded-modal-subtitle"></div>
<div>
    <button data-error-action id="mobile-wallet-adapter-error-action" class="mobile-wallet-adapter-embedded-modal-error-action">
        Find a wallet
    </button>
</div>
`;
const css = `
.mobile-wallet-adapter-embedded-modal-content {
    text-align: center;
}

.mobile-wallet-adapter-embedded-modal-error-icon {
    margin-top: 24px;
}

.mobile-wallet-adapter-embedded-modal-title {
    margin: 18px 100px auto 100px;
    color: #000000;
    font-size: 2.75em;
    font-weight: 600;
}

.mobile-wallet-adapter-embedded-modal-subtitle {
    margin: 30px 60px 40px 60px;
    color: #000000;
    font-size: 1.25em;
    font-weight: 400;
}

.mobile-wallet-adapter-embedded-modal-error-action {
    display: block;
    width: 100%;
    height: 56px;
    /*margin-top: 40px;*/
    font-size: 1.25em;
    /*line-height: 24px;*/
    /*letter-spacing: -1%;*/
    background: #000000;
    color: #FFFFFF;
    border-radius: 18px;
}

/* Smaller screens */
@media all and (max-width: 600px) {
    .mobile-wallet-adapter-embedded-modal-title {
        font-size: 1.5em;
        margin-right: 12px;
        margin-left: 12px;
    }
    .mobile-wallet-adapter-embedded-modal-subtitle {
        margin-right: 12px;
        margin-left: 12px;
    }
}
`;
//#endregion
//#region src/createDefaultWalletNotFoundHandler.ts
async function defaultErrorModalWalletNotFoundHandler() {
	if (typeof window !== "undefined") {
		const userAgent = window.navigator.userAgent.toLowerCase();
		const errorDialog = new ErrorModal();
		if (userAgent.includes("wv")) errorDialog.initWithError({
			name: "SolanaMobileWalletAdapterError",
			code: "ERROR_BROWSER_NOT_SUPPORTED",
			message: ""
		});
		else errorDialog.initWithError({
			name: "SolanaMobileWalletAdapterError",
			code: "ERROR_WALLET_NOT_FOUND",
			message: ""
		});
		errorDialog.open();
	}
}
function createDefaultWalletNotFoundHandler() {
	return async () => {
		defaultErrorModalWalletNotFoundHandler();
	};
}
//#endregion
//#region src/createDefaultAuthorizationCache.ts
const CACHE_KEY = "SolanaMobileWalletAdapterDefaultAuthorizationCache";
function createDefaultAuthorizationCache() {
	let storage;
	try {
		storage = window.localStorage;
	} catch {}
	return {
		async clear() {
			if (!storage) return;
			try {
				storage.removeItem(CACHE_KEY);
			} catch {}
		},
		async get() {
			if (!storage) return;
			try {
				const parsed = JSON.parse(storage.getItem(CACHE_KEY));
				if (parsed && parsed.accounts) {
					const parsedAccounts = parsed.accounts.map((account) => {
						return {
							...account,
							publicKey: "publicKey" in account ? new Uint8Array(Object.values(account.publicKey)) : base58.decode(account.address)
						};
					});
					return {
						...parsed,
						accounts: parsedAccounts
					};
				} else return parsed || void 0;
			} catch {}
		},
		async set(authorization) {
			if (!storage) return;
			try {
				storage.setItem(CACHE_KEY, JSON.stringify(authorization));
			} catch {}
		}
	};
}
//#endregion
//#region src/createDefaultChainSelector.ts
function createDefaultChainSelector() {
	return { async select(chains) {
		if (chains.length === 1) return chains[0];
		else if (chains.includes(SOLANA_MAINNET_CHAIN)) return SOLANA_MAINNET_CHAIN;
		else return chains[0];
	} };
}
//#endregion
export { LocalSolanaMobileWalletAdapterWallet, RemoteSolanaMobileWalletAdapterWallet, SolanaMobileWalletAdapterRemoteWalletName, SolanaMobileWalletAdapterWalletName, createDefaultAuthorizationCache, createDefaultChainSelector, createDefaultWalletNotFoundHandler, defaultErrorModalWalletNotFoundHandler, registerMwa };

//# sourceMappingURL=index.browser.js.map